import { render, staticRenderFns } from "./VideoHome.vue?vue&type=template&id=d1763014&"
import script from "./VideoHome.vue?vue&type=script&lang=js&"
export * from "./VideoHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports